import type { NamedFeatureToggle } from "@octopusdeploy/octopus-server-client";
import { links, type Url } from "@octopusdeploy/portal-routes";

export interface RetentionPolicy {
    type: string;
    description: string;
    pathFunction: (routeParams: { spaceId: string }) => Url;
    featureFlag?: NamedFeatureToggle;
}

export const policies: RetentionPolicy[] = [
    { type: "Built-in Package Retention", description: "This retention policy dictates how packages are kept in the built-in repository.", pathFunction: links.builtInPackageRetentionPoliciesPage.generateUrl, featureFlag: "centralized-retention-v2" },
    { type: "Release Retention", description: "This retention policy dictates how long releases and deployments are kept for.", pathFunction: links.releaseRetentionPoliciesPage.generateUrl },
    { type: "Runbook Retention", description: "This retention policy dictates how long Runbook runs are kept for.", pathFunction: links.runbookRetentionPoliciesPage.generateUrl, featureFlag: "centralized-retention-runbook" },
    { type: "Package Cache Retention", description: "This retention policy dictates how long packages are kept on targets and workers.", pathFunction: links.packageCacheRetentionPoliciesPage.generateUrl, featureFlag: "centralized-retention-v2" },
];
